import axios from 'axios'

export const backUser = `${process.env.NEXT_PUBLIC_URL_BACKEND}/${process.env.NEXT_PUBLIC_PUBLIC_API}`
export const backAdmin = `${process.env.NEXT_PUBLIC_URL_BACKEND}/${process.env.NEXT_PUBLIC_PUBLIC_API}/admin`

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';
//axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
//axios.defaults.withCredentials = true;
const axiosInstance = axios

export default axiosInstance